import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "manage-entities-dialog",
  class: "w-[640px] h-[640px] bg-white rounded-[8px] px-6 pb-8 pt-4"
}
const _hoisted_2 = { class: "flex justify-between items-center mb-5" }
const _hoisted_3 = {
  "data-testid": "manage-entities-dialog--title",
  class: "text-[20px] text-Text/text_high font-gordita-medium"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times text-[24px] !mr-0" }, null, -1)
const _hoisted_5 = { class: "row flex justify-between" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton, useIncrediDialog } from 'incredi-ui';
import { nextTick, ref } from 'vue';
import ManageSearch from '@/views/agents/components/manage-dialog/manageSearch.vue';
import AddEntityBtn from '@/views/agents/components/manage-dialog/addEntityBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'manageEntitiesDialog',
  props: {
    dialogTitle: null,
    modelValue: null,
    addEntity: null,
    dialogName: null,
    addEntityButtonTitle: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  dialogTitle: string;
  modelValue: string;
  addEntity: () => void;
  dialogName: string;
  addEntityButtonTitle: string;
}



const isClosed = ref(false);
const keepShowError = ref(false);
const dialog = useIncrediDialog();
const closeDialog = async () => {
  isClosed.value = true;
  await nextTick();
  if (!keepShowError.value) {
    dialog?.close(props.dialogName);
  }
  keepShowError.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.dialogTitle), 1),
          _createVNode(_unref(IncrediButton), {
            size: "small",
            design: "ghost-grey",
            fab: "",
            class: "w-[32px] -mr-2",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ManageSearch, {
            "model-value": __props.modelValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => emit('update:modelValue', val)),
            onSearchInputVal: _cache[1] || (_cache[1] = (val) => emit('update:modelValue', val))
          }, null, 8, ["model-value"]),
          _createVNode(AddEntityBtn, {
            "add-new-build-group": __props.addEntity,
            "button-title": __props.addEntityButtonTitle
          }, null, 8, ["add-new-build-group", "button-title"])
        ]),
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "table-slot", { isClosed: isClosed.value })
        ])
      ])
    ]),
    _: 3
  }))
}
}

})